import { AgGridReact } from 'ag-grid-react';
import { Theme, themeQuartz } from "ag-grid-community";
import React, { useEffect, useMemo, useState } from 'react';
import Loader from '../../../../components/loader';
import { StatusStaticCell, StatusStaticWRCell, titleCell } from '../../../../components/elements/function';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import { useWorkOrderApi } from '../../../../store/api/hooks/workOrderApiHook';
import toast from 'react-hot-toast';
import { showLocalDate } from '../../../../_common/functions';
import { URLS } from '../../../../_config';
import { useWorkRequestApi } from '../../../../store/api/hooks/workRequestApiHook';

const AssociatedWorkRequestList: React.FC = () => {
    const myTheme = themeQuartz.withParams({
        headerBackgroundColor: `#F0F0F0`
    });
    const params: any = useParams();
    const [rowData, setrowData] = useState<any>(null);
    const workOrderApi: any = useWorkOrderApi();
    const navigate = useNavigate();
    const theme = useMemo<Theme | "legacy">(() => {
        return myTheme;
    }, []);
    const workRequestAPI: any = useWorkRequestApi();


    const columnDefs = [
        {
            headerName: 'Work Request No', field: 'workRequestCode', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 140, cellRenderer: (data: any) => {
                return (
                    <p className='hover:text-primary font-semibold cursor-pointer truncate' title={data.value}> {data.value}  </p>
                )
            }, onCellClicked: (param: any) => {
                const url = URLS.WORK_REQUEST_DETAILS(param.data.workRequestID);
                window.open(url, '_blank');
            }
        },
        {
            headerName: 'Incident Date', field: 'incidentDate', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 120, cellRenderer: (data: any) => {
                return (
                    <p className='truncate' title={showLocalDate(data.value)}> {showLocalDate(data.value)}  </p>
                )
            }
        },
        { headerName: 'Facility', field: 'facilityName', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 120, cellRenderer: (params: any) => <p className="truncate" title={params.value}>{titleCell(params)}</p> },
        { headerName: 'Sub-Facility', field: 'subFacilityName', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 120, cellRenderer: (params: any) => <p className="truncate" title={params.value}>{titleCell(params)}</p> },
        {
            headerName: 'Description', field: 'description', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 150, cellRenderer: (data: any) => {
                return (
                    <p className='hover:text-primary font-semibold cursor-pointer truncate' title={data.value}>{data.value}</p>
                )
            }, onCellClicked: (param: any) => {
                const url = URLS.WORK_REQUEST_DETAILS(param.data.workRequestID);
                window.open(url, '_blank');
            }
        },
        { headerName: 'Priority', field: 'workRequestPriorityName', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 100, cellStyle: { textAlign: 'center' }, cellRenderer: (params: any) => <p className="truncate" title={params.value}>{titleCell(params)}</p> },
        { headerName: 'Requester', field: 'requsterName', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 120, cellRenderer: (data: any) => <p className="truncate" title={data.value}>{data.value} </p> },
        { headerName: 'Status', field: 'workRequestStatusName', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 100, cellRenderer: (params: any) => <div className="truncate" title={params.value}>{StatusStaticWRCell(params)}</div> },

    ];

    const GetWorkRequestList = (assetID: any = params.id) => {
        let payload: any = {
            assetID: assetID,
        };
        workRequestAPI.GetWorkRequestList(payload, (resp: any) => {
            console.log('resp =>', resp);
            setrowData(resp.workRequestList ? resp.workRequestList : []);
        }, (error: any) => {
            toast.error(error);
        });
    };

    useEffect(() => {
        if (params.id) {
            GetWorkRequestList(params.id);
        }
    }, [params]);

    return (
        <div>
            <div className="flex items-center justify-between h-[60px]">
                <h4 className="font-semibold text-[0.938rem]">Associated Work Request</h4>
            </div>
            <div className={`mb-3 ag-theme-alpine overflow-auto ${!rowData || rowData.length === 0 || rowData.length <= 2 ? 'h-[150px]' : 'h-[300px]'}`}>
                <AgGridReact
                    theme={theme}
                    columnDefs={columnDefs}
                    rowData={rowData || []}
                    pagination={false}
                    domLayout="normal"
                    ensureDomOrder={true}
                    suppressHorizontalScroll={false}
                    loadingOverlayComponent={Loader}
                    noRowsOverlayComponent={() => (
                        <div className="flex items-center justify-center h-full">
                            <div className="text-center text-gray-500">
                                <div className="text-lg font-medium">No Data Found</div>
                            </div>
                        </div>
                    )}
                />
            </div>
        </div>
    );
};

export default AssociatedWorkRequestList;